import TableColor from './TableColor';

export default TableColor;
